import { GetDailyNewsPracticeAreasDocument } from '__generated__/graphql';
import useSuspendableQuery from 'hooks/useSuspendableQuery';
import { useMemo } from 'react';

export function useUserPracticeAreas() {
  const { data } = useSuspendableQuery(GetDailyNewsPracticeAreasDocument);

  return useMemo(() => {
    const items =
      data.contentfulPracticeArea?.practiceAreaSubtopicsCollection?.items || [];

    const userAreas =
      data.user?.secondaryPracticeAreas?.selectedContentfulIds || [];

    const userPracticeAreas = items.filter(area =>
      userAreas.includes(area!.sys.id),
    );

    const allPracticeAreas = items.filter(
      area => !userAreas.includes(area!.sys.id),
    );

    return { items, userPracticeAreas, allPracticeAreas };
  }, [data]);
}
